@if ($pageState(); as vm) { @if (vm.status !== 'idle') {
<div class="flex flex-col gap-6 min-h-screen bg-neutral-50">
  <!-- @if (vm.pageResponse?.pageAsset?.layout?.header) { @if (vm.pageResponse?.content?.navigation?.children) {
  <custom-dot-cms-uve-header-navigation [items]="vm.pageResponse?.content?.navigation?.children || []" />
  } } -->
  <main class="container m-auto">
    @if (vm.status === 'loading') {
    <!-- <app-loading /> -->
    } @else if (vm.status === 'error' && vm.error) {
    <!-- <app-error [$error]="vm.error" /> -->
    } @else if (vm.status === 'success' && vm.pageResponse) {
    <dotcms-layout-body [page]="vm.pageResponse.pageAsset" [components]="components" />
    } @else {
    <!-- Add a fallback for unexpected states -->
    <p>Unexpected state encountered.</p>
    }
  </main>
</div>
} }

<!-- @if (pageState$ | async; as vm) {
<div class="flex flex-col gap-6 min-h-screen bg-neutral-50">
  <main class="container m-auto">
    @switch (vm.status) { @case ('loading') {
    <app-loading />
    } @case ('error') { @if (vm.error) {
    <app-error [$error]="vm.error" />
    } } @case ('success') { @if (vm.pageResponse) {
    <dotcms-layout-body [page]="vm.pageResponse.pageAsset" [components]="components" />
    } } @default {
    <p>Unexpected state encountered.</p>
    } }
  </main>
</div>
} -->
